import { get, post, put, remove } from 'api/request';
import urls from 'configs/urls';

export const getMasterServicesList = ({ data }) =>
  get(null, false, urls.masterServicesUrls.getMasterServices, data);

export const addMasterService = data =>
  post(null, false, urls.masterServicesUrls.addMasterService, data);

export const editMasterService = data =>
  put(null, false, `${urls.masterServicesUrls.editMasterService}/${data.MasterServiceKey}`, data);

export const deleteMasterService = data =>
  remove(null, false, `${urls.masterServicesUrls.deleteMasterService}/${data.masterServiceKey}`);

export const getCategories = () => get(null, false, urls.masterServicesUrls.getCategories);
